export default {
  error(vue, message) {
    vue.$toasted.error(
      `<div style="display:flex;align-items:center;gap:8px;">
        <i class='fa fa-times-circle'></i>
        <span>${message}</span>
      </div>`,
      {
        duration: 3000,
        position: "top-right",
      }
    )
  },

  success(vue, message) {
    vue.$toasted.success(
      `<div style="display:flex;align-items:center;gap:8px;">
        <i class='fa fa-check-circle'></i>
        <span>${message}</span>
      </div>`,
      {
        duration: 3000,
        position: "top-right",
      }
    )
  }
}
